/**
 * Denis Callinan
 * Project Andromeda
 * August 4th, 2020
 * ProjectBox.js - Portfolio component
 */

import React from 'react';

// CSS
import './ProjectBox.css';

// Media
import gh from '../../img/contact/gh.png';

export default class ProjectBox extends React.Component {
    render() {
        // Mobile / Normal
        if (this.props.width > 950) {
            // Check which justification type
            var type = this.props.type % 2 ? "left": "right";

            // Map skills grid
            var skills = this.props.skills.map(skill => {
                return <p id = "proj-skill">{skill}</p>;
            });

            // Check/render git
            var git = this.props.gh ? 
                <div className = "projLinks" id = {"proj-links-" + type}>
                    <input type="image" className = "mediaLogo" src = {gh}  alt = "GitHub" />
                </div>
            : null;

            return(
                <div className = {"projectComponent" + type} id = {this.props.gh ? "has-git": "no-git"}>
                    <h4 className = "projTitle" id = {"title-" + type}>{this.props.name}</h4>
                    <p className = "projDesc" id = {"desc-" + type}>{this.props.desc}</p>
                    <img className = "projImg" id = {"proj-img-" + type} src = {require('../../img/proj/' + this.props.src)} alt = "Project" />
                    <div className = "projSkills" id = {"proj-skills-" + type}>
                        {skills}
                    </div>
                    {git}
                </div>
            );
        } else {
            return(
                <div className = "projectComponentMobile">
                    <h4 id = "proj-title-mobile">{this.props.name}</h4>
                    <img id = "proj-img-mobile" src = {require('../../img/proj/' + this.props.src)} alt = "Project" />
                    <p id = "proj-desc-mobile">{this.props.desc}</p>
                </div>
            ); 
        }
    }
}